import parseAccountInfo from 'lib/parseAccountInfo';
import gigya from 'api/gigya';
import * as analytics from 'analytics';
import { playbackModes } from 'store/reducers/player';
import { accountInfoLoaded } from 'actions/lifecycle-actions';
import { isHDsupported } from 'util/device';
import { gigyaActions } from './actions-const';
import { playLiveAudio } from './player-actions';
import logger from 'util/logger';
import { openScreenset } from 'api/gigya';
import { NotificationTypes, NotificationTexts } from '../components/Notifications/Notification';
import { showNotification } from 'actions/notifications-actions';

export function attemptLogin(autoPlayAfterLogin = false) {
  return (dispatch) => {
    dispatch({ type: gigyaActions.ATTEMPT_LOGIN, autoPlayAfterLogin });
  };
}

export function setUserHDPreference(prefersHD, trackAnalytics = true, autoplay = false) {
  return (dispatch, getState) => {
    const {
      user: { isLoggedIn },
      player: { currentStation, playbackMode },
    } = getState();

    if (trackAnalytics) {
      analytics.trackHDPreference(prefersHD);
    }

    if (isLoggedIn) {
      // Update Gigya Settings
      window.gigya?.accounts?.setAccountInfo({
        data: { radio_juke_prefers_hd: prefersHD },
        callback: (response) => response.status === 'FAIL' && logger.warn(response.statusMessage),
      });
    }

    dispatch({
      type: gigyaActions.PREFERS_HD_SOURCES,
      payload: prefersHD,
    });

    if (
      autoplay &&
      prefersHD &&
      currentStation &&
      currentStation.tritonMountHD &&
      playbackMode === playbackModes.LIVE_AUDIO
    ) {
      dispatch(playLiveAudio());
    }
  };
}

export function login(accountInfo) {
  return (dispatch, getState) => {
    const {
      user,
      player: { currentStation, playbackMode },
    } = getState();
    dispatch({
      type: gigyaActions.LOGIN,
      accountInfo,
    });

    dispatch(accountInfoLoaded());

    const prefersHD = user.prefersHDSources || accountInfo.data.radio_juke_prefers_hd;
    if (user.prefersHDSources) {
      // Update Gigya accountInfo
      window.gigya?.accounts?.setAccountInfo({
        data: { radio_juke_prefers_hd: true },
        callback: (response) => response.status === 'FAIL' && logger.warn(response.statusMessage),
      });
    } else if (accountInfo.data.radio_juke_prefers_hd && isHDsupported()) {
      dispatch(setUserHDPreference(true, false));
    }

    // Start HD Stream
    if (
      prefersHD &&
      user.attemptingLogin && // Only start stream if user preeviously interacted with website
      currentStation &&
      currentStation.tritonMountHD &&
      playbackMode === playbackModes.LIVE_AUDIO &&
      user.autoPlayAfterLogin
    ) {
      dispatch(playLiveAudio());
    }
  };
}

export function updateProfile(accountInfo) {
  return (dispatch) => {
    dispatch({
      type: gigyaActions.UPDATE_PROFILE,
      accountInfo,
    });
  };
}

export function loadAccountInfo() {
  return (dispatch) => {
    dispatch({ type: gigyaActions.ACCOUNT_INFO_LOADING });
    window.gigya?.accounts?.getAccountInfo({
      callback: (response) => {
        if (response.status === 'FAIL' && response.errorCode === 403005) {
          dispatch({ type: gigyaActions.NOT_LOGGED_IN });
          dispatch(accountInfoLoaded());
        } else if (response.status === 'OK' && response.errorCode === 0) {
          dispatch(login(parseAccountInfo(response)));
        } else {
          logger.error('getAccountInfo > Unexpected errorCode', response);
          dispatch(accountInfoLoaded());
        }
      },
    });
  };
}

export function logout() {
  gigya.clearGigyaToken();

  return (dispatch, getState) => {
    const {
      user,
      player: { isPlaying, currentStation, playbackMode },
    } = getState();
    dispatch(
      showNotification({
        type: NotificationTypes.NOTIFICATION,
        message: NotificationTexts.LOGOUT_SUCCESS,
      })
    );

    dispatch({ type: gigyaActions.LOGOUT });

    if (user.prefersHDSources) {
      dispatch(setUserHDPreference(false, false));
      // Switch to SD stream
      if (isPlaying && currentStation && currentStation.tritonMountHD && playbackMode === playbackModes.LIVE_AUDIO) {
        dispatch(playLiveAudio());
      }
    }
  };
}

export function showTalpaGigyaModal(screenSet, startScreen, autoPlayAfterLogin = true) {
  return (dispatch) => {
    dispatch(attemptLogin(autoPlayAfterLogin));
    openScreenset(screenSet, startScreen);
  };
}
